module.exports = __webpack_public_path__ + "static/media/zero-to-mastery.d0a70af7.png";